import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { AppSession } from 'src/app/models/app-session';

@Component({
  selector: 'app-identification-layout',
  templateUrl: './identification-layout.component.html'
})

export class IdentificationLayoutComponent implements OnInit {

  expired = AppSession.getExpired() === '1' ? true : false;

  constructor(public translate: TranslateService,
              @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.document.body.classList.remove('body-content');
    this.document.body.classList.add('background-image');
  }

}
